import { render, staticRenderFns } from "./drawCardFail.vue?vue&type=template&id=2035f9bf&scoped=true&"
import script from "./drawCardFail.vue?vue&type=script&lang=js&"
export * from "./drawCardFail.vue?vue&type=script&lang=js&"
import style0 from "./drawCardFail.vue?vue&type=style&index=0&id=2035f9bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035f9bf",
  null
  
)

export default component.exports